import React, { FunctionComponent } from "react";
import Header from "./header/Header";
import Footer from "./Footer";
import ContactUs from "../sections/ContactUs";
// @ts-ignore
import logo from "../../assets/images/logo.svg";
// @ts-ignore
import logo_dark from "../../assets/images/logo_dark.svg";
import { Link } from "gatsby";
import { twMerge } from "tailwind-merge";
import { Button } from "../Button";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";

type LandingLayoutProps = {
  darkHeader?: boolean;
};

const LandingLayout: FunctionComponent<LandingLayoutProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen overflow-x-clip">
      <div className={twMerge(props.darkHeader && "bg-gray-900")}>
        <div className="z-50 container mx-auto px-4 sm:px-6 h-24 flex items-center justify-between">
          <Link to="/">
            <span className="sr-only">Astrorei</span>
            <img
              className="h-auto w-44 sm:h-12 mt-[-5px]"
              src={props.darkHeader ? logo_dark : logo}
              alt="Astrorei logo"
            />
          </Link>
          <Button
            variant="secondary"
            to="#contact-form"
            label={t("landing:common.headerCta")}
            className="z-50 w-fit hidden md:block"
          />
        </div>
      </div>
      <SEO noindex title="Astrorei" />
      {props.children}
      <ContactUs variant="accent" withCall={false} />
      <Footer compact />
    </div>
  );
};

export default LandingLayout;
